import { v4  } from 'uuid';

export function uuidv4() {
    return v4()
}
